/**
 * Minimal runtime deps for lucky wheel (ported from oldTheme img_data.js).
 * Requires jQuery and jQuery.cookie.
 */
(function () {
  window.theme = window.theme || {};

  function AjaxApi(url, data, method) {
    data = data || {};
    data.shopId = String(theme.shopId || '');
    var BASE_URL = 'https://sw.ahaselected.com';
    return $.ajax({
      method: method || 'GET',
      url: BASE_URL + '/aha-web' + url,
      contentType: 'application/json',
      data: method ? JSON.stringify(data) : data,
    }).then(function (response) {
      return response;
    });
  }

  window.AjaxApi = AjaxApi;
})();
